import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useHighlightHandlers } from '../../contexts/HighlightContext/Highlight';
import { Typography as MuiTypography } from '@mui/material';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import ReactMarkdown from 'react-markdown';

const Typography = React.forwardRef<HTMLInputElement, any>((props, ref) =>
  useHighlightHandlers(MuiTypography, { forwardedRef: ref, ...props }),
);

// @ts-ignore Todo: Complete type definitions for DefaultContent.
export function DefaultContent({ children, body }) {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up('md'));
  const h1Ref = React.useRef<HTMLInputElement | null>(null);
  const h2Ref = React.useRef<HTMLInputElement | null>(null);
  const h3Ref = React.useRef<HTMLInputElement | null>(null);
  const h4Ref = React.useRef<HTMLInputElement | null>(null);
  const h5Ref = React.useRef<HTMLInputElement | null>(null);
  const h6Ref = React.useRef<HTMLInputElement | null>(null);
  const subtitle1Ref = React.useRef<HTMLInputElement | null>(null);
  const subtitle2Ref = React.useRef<HTMLInputElement | null>(null);
  const body1Ref = React.useRef<HTMLInputElement | null>(null);
  const body2Ref = React.useRef<HTMLInputElement | null>(null);
  const buttonRef = React.useRef<HTMLInputElement | null>(null);
  const captionRef = React.useRef<HTMLInputElement | null>(null);
  const overlineRef = React.useRef<HTMLInputElement | null>(null);

  return (
    <Paper elevation={1} sx={{ padding: theme.spacing(md ? 4 : 2), marginBottom: theme.spacing(md ? 4 : 2) }}>
      {children}
      {body ? <ReactMarkdown>{body}</ReactMarkdown> : (
        <>
          <div style={{ margin: theme.spacing(0, 0, 4) }}>
            <Typography variant="subtitle1">Primary</Typography>
            <Grid
              container
              spacing={0}
            >
              <Grid item sx={{ backgroundColor: theme.palette.primary.light, padding: theme.spacing(2) }}>light</Grid>
              <Grid item sx={{ backgroundColor: theme.palette.primary.main, padding: theme.spacing(2) }}>main</Grid>
              <Grid item sx={{ backgroundColor: theme.palette.primary.dark, padding: theme.spacing(2) }}>dark</Grid>
              <Grid item sx={{
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                padding: theme.spacing(2),
              }}>contrastText</Grid>
            </Grid>
          </div>
          <div style={{ margin: theme.spacing(0, 0, 4) }}>
            <Typography variant="subtitle1">Secondary</Typography>
            <Grid
              container
              spacing={0}
            >
              <Grid item sx={{ backgroundColor: theme.palette.secondary.light, padding: theme.spacing(2) }}>light</Grid>
              <Grid item sx={{ backgroundColor: theme.palette.secondary.main, padding: theme.spacing(2) }}>main</Grid>
              <Grid item sx={{ backgroundColor: theme.palette.secondary.dark, padding: theme.spacing(2) }}>dark</Grid>
              <Grid item sx={{
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.secondary.contrastText,
                padding: theme.spacing(2),
              }}>contrastText</Grid>
            </Grid>
          </div>
          <div style={{ margin: theme.spacing(0, 0, 4) }}>
            <Typography variant="subtitle1">Grey</Typography>
            <Grid
              container
              spacing={0}
            >
              <Grid item sx={{ backgroundColor: theme.palette.grey['50'], padding: theme.spacing(2) }}>50</Grid>
              <Grid item sx={{ backgroundColor: theme.palette.grey['100'], padding: theme.spacing(2) }}>100</Grid>
              <Grid item sx={{ backgroundColor: theme.palette.grey['200'], padding: theme.spacing(2) }}>200</Grid>
              <Grid item sx={{ backgroundColor: theme.palette.grey['300'], padding: theme.spacing(2) }}>300</Grid>
              <Grid item sx={{ backgroundColor: theme.palette.grey['400'], padding: theme.spacing(2) }}>400</Grid>
              <Grid item sx={{ backgroundColor: theme.palette.grey['500'], padding: theme.spacing(2) }}>500</Grid>
              <Grid item sx={{ backgroundColor: theme.palette.grey['600'], padding: theme.spacing(2) }}>600</Grid>
              <Grid item sx={{ backgroundColor: theme.palette.grey['700'], padding: theme.spacing(2) }}>700</Grid>
              <Grid item sx={{ backgroundColor: theme.palette.grey['800'], padding: theme.spacing(2) }}>800</Grid>
              <Grid item sx={{ backgroundColor: theme.palette.grey['900'], padding: theme.spacing(2) }}>900</Grid>
              <Grid item sx={{ backgroundColor: theme.palette.grey['A100'], padding: theme.spacing(2) }}>A100</Grid>
              <Grid item sx={{ backgroundColor: theme.palette.grey['A200'], padding: theme.spacing(2) }}>A200</Grid>
              <Grid item sx={{ backgroundColor: theme.palette.grey['A400'], padding: theme.spacing(2) }}>A400</Grid>
              <Grid item sx={{ backgroundColor: theme.palette.grey['A700'], padding: theme.spacing(2) }}>A700</Grid>
            </Grid>
          </div>
          <div style={{ margin: theme.spacing(0, 0, 4) }}>
            <Typography variant="subtitle1">Text</Typography>
            <Grid
              container
              spacing={0}
            >
              <Grid item sx={{ color: theme.palette.text['primary'], padding: theme.spacing(2) }}>primary</Grid>
              <Grid item sx={{ color: theme.palette.text['secondary'], padding: theme.spacing(2) }}>secondary</Grid>
              <Grid item sx={{ color: theme.palette.text['disabled'], padding: theme.spacing(2) }}>disabled</Grid>
            </Grid>
          </div>
          <div style={{ margin: theme.spacing(0, 0, 4) }}>
            <Typography variant="subtitle1">H1</Typography>
            <Typography ref={h1Ref} variant="h1">Almost before we knew it, we had left the ground.</Typography>
          </div>
          <div style={{ margin: theme.spacing(0, 0, 4) }}>
            <Typography variant="subtitle1">H2</Typography>
            <Typography ref={h2Ref} variant="h2">Almost before we knew it, we had left the ground.</Typography>
          </div>
          <div style={{ margin: theme.spacing(0, 0, 4) }}>
            <Typography variant="subtitle1">H3</Typography>
            <Typography ref={h3Ref} variant="h3">Almost before we knew it, we had left the ground.</Typography>
          </div>
          <div style={{ margin: theme.spacing(0, 0, 4) }}>
            <Typography variant="subtitle1">H4</Typography>
            <Typography ref={h4Ref} variant="h4">Almost before we knew it, we had left the ground.</Typography>
          </div>
          <div style={{ margin: theme.spacing(0, 0, 4) }}>
            <Typography variant="subtitle1">H5</Typography>
            <Typography ref={h5Ref} variant="h5">Almost before we knew it, we had left the ground.</Typography>
          </div>
          <div style={{ margin: theme.spacing(0, 0, 4) }}>
            <Typography variant="subtitle1">H6</Typography>
            <Typography ref={h6Ref} variant="h6">Almost before we knew it, we had left the ground.</Typography>
          </div>
          <div style={{ margin: theme.spacing(0, 0, 4) }}>
            <Typography variant="subtitle1">subtitle1</Typography>
            <Typography ref={subtitle1Ref} variant="subtitle1">Almost before we knew it, we had left the ground.</Typography>
          </div>
          <div style={{ margin: theme.spacing(0, 0, 4) }}>
            <Typography variant="subtitle1">subtitle2</Typography>
            <Typography ref={subtitle2Ref} variant="subtitle2">Almost before we knew it, we had left the ground.</Typography>
          </div>
          <div style={{ margin: theme.spacing(0, 0, 4) }}>
            <Typography variant="subtitle1">body1</Typography>
            <Typography ref={body1Ref} variant="body1">Almost before we knew it, we had left the ground.</Typography>
          </div>
          <div style={{ margin: theme.spacing(0, 0, 4) }}>
            <Typography variant="subtitle1">body2</Typography>
            <Typography ref={body2Ref} variant="body2">Almost before we knew it, we had left the ground.</Typography>
          </div>
          <div style={{ margin: theme.spacing(0, 0, 4) }}>
            <Typography variant="subtitle1">button</Typography>
            <Typography ref={buttonRef} variant="button">Almost before we knew it, we had left the ground.</Typography>
          </div>
          <div style={{ margin: theme.spacing(0, 0, 4) }}>
            <Typography variant="subtitle1">caption</Typography>
            <Typography ref={captionRef} variant="caption">Almost before we knew it, we had left the ground.</Typography>
          </div>
          <div style={{ margin: theme.spacing(0, 0, 4) }}>
            <Typography variant="subtitle1">overline</Typography>
            <Typography ref={overlineRef} variant="overline">Almost before we knew it, we had left the ground.</Typography>
          </div>
        </>
      )}
    </Paper>
  );
}